import autosaveService from '../common/services/AutosaveService';


$(document).on('ajax:send', '.destroy-interest', () => {
    autosaveService.activateAnimation();
    autosaveService.saveStarted();
});
$(document).on('ajax:complete', '.destroy-interest', (event) => {
    autosaveService.saveFinished();
    let $element = $(event.target);
    $element.closest('form').remove();
    $(document).trigger('interests:destroyed');
});